import Grid from '@mui/material/Grid2';
import { OpenAiSettings } from './OpenAiSettings';

export const AiSettings = () => {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          xs: 12,
          lg: 6,
        }}
      >
        <OpenAiSettings />
      </Grid>
    </Grid>
  );
};
